module.exports = __webpack_public_path__ + "static/img/s25.f68efc1f.png";